export function getElementHeight(element) {
  return element?.getBoundingClientRect()?.height || 0;
}

export function getElementWidth(element) {
  return element?.getBoundingClientRect()?.width || 0;
}
